var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"m13.5 5-3 14m3.5 0H7M17 5h-7"}})
}
var staticRenderFns = []

export { render, staticRenderFns }